<template>
  <div class="searchRange">
    <div class="header">
      <span>搜索范围</span>
      <i class="iconfont icon-guanbi2" @click="handleDelete" />
    </div>
    <div class="content">
      <el-row>
        <el-col :span="8" class="content-title">分析任务</el-col>
        <el-col :span="16"
          ><h-button
            @click="handleSearchRange('任务')"
            class="content-btn"
            :disabled="videoList.length > 0"
            >选择分析任务</h-button
          ></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8" class="content-title">线索摸排任务</el-col>
        <el-col :span="16"
          ><h-button
            @click="handleSearchRange('线索')"
            class="content-btn"
            :disabled="videoList.length > 0"
            >选择线索摸排任务</h-button
          ></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8" class="content-title">摄像机</el-col>
        <el-col :span="16"
          ><h-button @click="handleSearchRange('摄像机')" class="content-btn">{{
            videoCameraList.length > 0
              ? `已选择${videoCameraList.length}个摄像机`
              : "选择摄像机"
          }}</h-button></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8" class="content-title">视频文件</el-col>
        <el-col :span="16"
          ><h-button @click="handleSearchRange('视频')" class="content-btn">{{
            videoList.length > 0
              ? `已选择${videoList.length}个视频文件`
              : "选择视频文件"
          }}</h-button></el-col
        >
      </el-row>
      <!-- <el-row>
        <el-col :span="8" class="content-title">行政区域</el-col>
        <el-col :span="16"
          ><h-button @click="handleSearchRange('行政区域')" class="content-btn"
            >选择行政区域</h-button
          ></el-col
        >
      </el-row> -->
    </div>
    <div class="footer">
      <h-button type="primary" @click="submit" class="sure">确定</h-button>
      <h-button @click="reset">重置</h-button>
    </div>
  </div>
  <transfer-application
    v-if="transferVisible"
    v-model:visible="transferVisible"
    v-model:dataType="searchRangeType"
    :title="searchRangeTitle"
    @transferApplicationList="getTransferList"
  ></transfer-application>
  <el-dialog v-model="uniqueVisible" :title="searchRangeTitle" width="50%">
    <unique-transfer v-model:dataType="searchRangeType"></unique-transfer>
  </el-dialog>
</template>
<script>
import moment from "moment";
import util from "@util/js";
import _ from "lodash";
import { defineComponent, reactive, toRefs, watchEffect, onMounted } from "vue";
import {
  getResources,
  createClueTask,
} from "@/api/smartApplication/smartApplicationApi.js";
import { ElMessage } from "element-plus";
import uniqueTransfer from "./uniqueTransfer";
export default defineComponent({
  name: "searchRange",
  components: { uniqueTransfer },
  props: {},
  emits: ["closeSearchRange"],
  setup(props, context) {
    const state = reactive({
      transferVisible: true,
      uniqueVisible: false,
      searchRangeType: "摄像机", //穿梭框默认展示摄像机数据
      searchRangeTitle: "摄像机选择", //穿梭框标题

      videoCameraList: [], //存选择的摄像头
      videoList: [], //存选择的摄像头
    });
    const refData = toRefs(state);
    const handleSearchRange = (val) => {
      state.showSearchRange = true;
      if (val == "任务" || val == "线索") {
        state.uniqueVisible = true;
      } else {
        state.transferVisible = true;
      }
      state.searchRangeType = val;
      state.searchRangeTitle = val + "选择";
    };
    //获取穿梭框摄像头数据
    const getTransferList = (val) => {
      if (val.length > 0) {
        if (val[0].cameraId != undefined) {
          state.videoCameraList = val;
        } else {
          state.videoList = val;
        }
      }
    };
    const handleDelete = () => {
      context.emit("closeSearchRange");
    };
    const submit = () => {
      context.emit("closeSearchRange", state);
    };
    return {
      ...refData,
      submit,
      handleSearchRange,
      handleDelete,
      getTransferList,
    };
  },
});
</script>
<style lang="scss" scoped>
.searchRange {
  position: absolute;
  z-index: 1;
  left: 400px;
  top: 15%;
  width: 426px;
  height: 350px;
  background-color: rgba($color: #476287, $alpha: 0.9);

  .header {
    height: 42px;
    padding: 0 15px;
    border-bottom: 1px solid #486199;
    @include flex-row-sb-c;
    i {
      color: red;
    }
  }
  .content {
    height: calc(100% - 106px);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .content-title {
      text-align: end;
    }
    .content-btn {
      margin-left: 24px;
      width: 70%;
      // &:hover {
      //   background-color: cadetblue;
      // }
    }
  }
  .footer {
    @include flex-row-c-c;
    margin: 16px;
    .sure {
      &:hover {
        background-color: cadetblue;
      }
    }
  }
}
</style>
